// extracted by mini-css-extract-plugin
export default {"root":"SourceInfo_root__BScKO","info":"SourceInfo_info__+Jaeb","cur":"SourceInfo_cur__a8yuT","list":"SourceInfo_list__SiiZh","icon":"SourceInfo_icon__kwcEd"};